<div class=" AModalContent modal-content am-modal-content modal-md text-white bg-am-medium-blue">
    <div class="am-close-div bg-am-medium-blue">
      <button type="button" class=" text-am-white am-modal-close" (click)="modal.dismiss()">
        <img src="assets/images/usPerson/closeModal.svg" alt="close">
      </button>
    </div>

      <div class="AMModalBody d-flex flex-column bg-am-medium-blue align-baseline justify-content-between p-4 bg-am-medium-blue w-100">
        <div class="modal-wait-image bg-am-medium-blue ">
            <img src="assets/images/alert/acute.svg" alt="warning" width="140px">
        </div>

        <p class="wait-modal-title w-100 text-center text-wrap bg-am-medium-blue">{{ 'waitmodal.sessionExpired' | translate }} {{ timer }} {{ 'waitmodal.sessionExpired2' | translate }} </p>

        <p class="wait-modal-paragraf text-center text-wrap bg-am-medium-blue">{{ 'waitmodal.needTime' | translate }}</p>

      </div>
      <div class="bg-am-medium-blue d-flex flex-row justify-content-around">
        <button type="button" class="btn am-alert-button custom-checkbox  am-alert-button-cancel text-wrap" (click)="onCancel()">{{ 'waitmodal.button.endSession' | translate }}</button>
        <button type="button" class="btn am-alert-button  am-alert-button-confirm text-wrap" (click)="onConfirm()">{{ 'waitmodal.button.continue'| translate }}</button>
      </div>


  </div>
